// This file is automatically compiled by Webpack, along with any other files
// present in this directory. You're encouraged to place your actual application logic in
// a relevant structure within app/javascript and only use these pack files to reference
// that code so it'll be compiled.

require("@rails/ujs").start()

require("@rails/activestorage").start()
require("channels")

require('jquery');

import "bootstrap"
import "@fortawesome/fontawesome-free/js/all";
import "../stylesheets/application";

import $ from 'jquery';
global.$ = jQuery;

require( 'jquery' );
require( 'datatables.net-bs4' );
require( 'datatables.net-autofill' );
require( 'datatables.net-autofill-bs4' );
require( 'datatables.net-responsive-bs4' );
require( 'datatables.net-rowgroup-bs4' );
require( 'datatables.net-scroller-bs4' );

require( 'jszip' );
require( 'pdfmake' );
require( 'datatables.net-buttons-bs4' )();
require( 'datatables.net-buttons/js/buttons.html5.js' )();
require( 'datatables.net-buttons/js/buttons.print.js' )();
